import { render } from "./pasien.vue?vue&type=template&id=8880a33e&scoped=true"
import script from "./pasien.vue?vue&type=script&lang=js"
export * from "./pasien.vue?vue&type=script&lang=js"

import "./pasien.vue?vue&type=style&index=0&id=8880a33e&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8880a33e"]])

export default __exports__